<template>
    <div class="d-flex overflow-hidden">
        <div
            class="d-flex justify-content-center align-items-start flex-shrink-0"
            style="width: 40px"
        >
            <icon
                v-if="notification.type === 'location.access.granted'"
                icon="cil-check-circle"
                style="height: 22px"
            />
            <icon
                v-else
                class="text-danger"
                icon="cil-x-circle"
                style="height: 22px"
            />
        </div>
        <div class="overflow-hidden">
            <div>
                <b class="text-truncate d-block">{{ title }}</b>
            </div>
            <small class="d-block text-muted" v-html="description" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'airport.user.synched',
    props: {
        notification: {},
    },
    computed: {
        title() {
            return this.trans(`notification.${this.notification.type}.title`);
        },
        description() {
            let { type, payload } = this.notification;
            const airports = payload
                .map((a) => {
                    let iataCode =
                        a.attributes?.find((attr) => attr.key === 'iataCode')
                            ?.value || a.iataCode;

                    return iataCode ? `${a.name} (${iataCode})` : a.name;
                })
                .join('<br />');
            // Translate asset status
            return this.trans(`notification.${type}`, { airports });
        },
    },
};
</script>
